export default "__VITE_ASSET__BzB9TR8G__"